var map = {
	"./alien.png": 76640,
	"./bomb.png": 9561,
	"./bowling.png": 87522,
	"./cold_face.png": 82532,
	"./cow_face.png": 87702,
	"./cowboy_hat_face.png": 72330,
	"./dog_face.png": 57858,
	"./fire.png": 20252,
	"./flying_saucer.png": 47586,
	"./frog.png": 90582,
	"./ghost.png": 93269,
	"./hear_no_evil_monkey.png": 98060,
	"./honeybee.png": 53941,
	"./horse.png": 55727,
	"./kangaroo.png": 55022,
	"./oncoming_police_car.png": 47030,
	"./owl.png": 22879,
	"./penguin.png": 2501,
	"./person_juggling.png": 8550,
	"./pig_face.png": 36384,
	"./pile_of_poo.png": 16915,
	"./popcorn.png": 68128,
	"./rabbit_face.png": 97378,
	"./robot.png": 56709,
	"./rocket.png": 52169,
	"./roller_coaster.png": 21626,
	"./sloth.png": 74021,
	"./smiling_face_with_horns.png": 87385,
	"./smiling_face_with_sunglasses.png": 12910,
	"./snowman.png": 6922,
	"./soccer_ball.png": 38694,
	"./spouting_whale.png": 16179,
	"./unicorn.png": 12854,
	"./volcano.png": 449,
	"./zombie.png": 93111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67218;